import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSearchParams } from "react-router-dom";
import { SEARCH_PARAMS } from "../../../utils/SearchParams";
import { KEY_NAME } from "../../../utils/KeyName";
import {
  faChartSimple,
  faChartLine,
  faBorderAll,
  faFileLines,
  faMagnifyingGlass,
  faBook,
  faCircleInfo,
} from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { AppContext } from "../../../context/AppContext";
import { useContext } from "react";

import "./Sidebar.scss";

function Sidebar() {
  const currentLocation = useLocation();

  const [searchParams] = useSearchParams();

  const allowedParams = [
    SEARCH_PARAMS.ENTITY_NAME,
    SEARCH_PARAMS.SHORT_NAME,
    SEARCH_PARAMS.ENTITY_ID,
  ];

  const filteredSearch = new URLSearchParams();
  const { entityName } = useContext(AppContext);

  const SidebarItems = [
    {
      icon: faChartSimple,
      title: "Publication Analytics",
      tooltip: "Publication Analytics",
      url: `/${entityName}/publication-analytics`,
      module: "publicationAnalytics",
    },
    {
      icon: faChartLine,
      title: "Dataset Analytics",
      tooltip: "Dataset Analytics",
      url: `/${entityName}/dataset-analytics`,
      module: "datasetAnalytics",
    },
    {
      icon: faBorderAll,
      title: "Publication Data",
      tooltip: "Publication Data",
      url: `/${entityName}/publication-data`,
      module: "publicationData",
    },
    {
      icon: faFileLines,
      title: "Reports",
      tooltip: "Reports",
      url: `/${entityName}/reports`,
      module: "reports",
    },
    {
      icon: faMagnifyingGlass,
      title: "Lookup",
      tooltip: "Lookup",
      url: `/${entityName}/lookup`,
      module: "lookup",
    },
    // {
    //   icon: faBook,
    //   title: "Glossary",
    //   tooltip: "Glossary",
    //   url: `/${entityName}/glossary`,
    //   module: "glossary",
    // },
    {
      icon: faCircleInfo,
      title: "About",
      tooltip: "About",
      url: `/${entityName}/about`,
      module: "about",
    },
  ];

  allowedParams.forEach((key) => {
    const value = searchParams.get(key);
    if (value) filteredSearch.set(key, value);
  });

  return (
    <div>
      {SidebarItems.map((item, index) => {
        return (
          // <div
          //   key={index}
          //   className={`d-flex flex-column align-items-center py-3 px-2  ${
          //     currentLocation.pathname === item.url ? "text-primary" : ""
          //   }`}
          //   title={item.tooltip}
          // >
          //   <FontAwesomeIcon icon={item.icon} size="2x" />
          //   <span className="text-wrap">{item.title}</span>
          // </div>
          <NavLink
            key={index}
            to={{
              pathname: item.url,
              search: filteredSearch.toString(), //window.location.search
            }}
            className={({ isActive }) =>
              `d-flex flex-column align-items-center justify-content-center text-center text-decoration-none my-4 px-2 ${
                isActive ? "active-tab" : "text-secondary"
              }`
            }
            title={item.tooltip}
          >
            <FontAwesomeIcon icon={item.icon} size="2x" />
            <span className="text-wrap">{item.title}</span>
          </NavLink>
        );
      })}
    </div>
  );
}

export default Sidebar;
